<div class="vitamui-input" [class.disabled]="control.disabled">
  <label>
    {{ label | translate }}
    @if (isRequired()) {
      <span class="required-marker">*</span>
    }
  </label>
  <input
    class="hidden-input"
    [matDatepicker]="datepicker"
    [value]="datePickerValue"
    (dateChange)="onDateChange('day', $event.value)"
    [min]="min"
    [max]="max"
  />
  <input
    #vitamUIInput
    [disabled]="control.disabled"
    [required]="isRequired()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [ngModel]="displayedValue"
    (ngModelChange)="onTextChange($event)"
  />
  <mat-datepicker-toggle [for]="datepicker" matSuffix>
    <mat-icon matDatepickerToggleIcon><i class="vitamui-icon vitamui-icon-calendar"></i></mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker
    #datepicker
    panelClass="picker"
    [startView]="startView"
    [disabled]="control.disabled"
    (yearSelected)="onDateChange('year', $event)"
    (monthSelected)="onDateChange('month', $event)"
  ></mat-datepicker>
</div>
<div #hintArea class="hint-area">
  @if (hint && (control.valid || control.disabled || control.pristine)) {
    <div class="info">
      <i class="vitamui-icon vitamui-icon-info"></i>
      @if (hint) {
        <mat-hint> {{ hint | translate }} </mat-hint>
      }
    </div>
  }
</div>
<vitamui-form-errors
  [control]="control"
  [errorMessageMap]="{
    pattern: 'DATE.EXPECTED_FORMAT' | translate: { format: 'DATE.FORMAT.' + selectedFormat() | translate },
    invalidDate: 'DATE.INVALID' | translate,
  }"
></vitamui-form-errors>
